export default {
  tags: [
    { name: 'Сastles', count: 2 },
    { name: 'Сhurches', count: 2 },
    { name: 'Monuments', count: 1 },
    { name: 'Museums', count: 3 },
    { name: 'Palaces', count: 1 },
    { name: 'Parks', count: 1 },
    { name: 'Towers', count: 1 },
  ],
  places: [
    {
      id: 1,
      lat: 55.751999,
      lon: 37.617734,
      name: 'Moscow Kremlin',
      photo:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Moscow_05-2012_Kremlin_22.jpg/440px-Moscow_05-2012_Kremlin_22.jpg',
      tags: ['Сastles', 'Сhurches', 'Museums'],
    },
    {
      id: 2,
      lat: 54.786389,
      lon: 32.065556,
      name: 'Smolensk Kremlin',
      photo:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/BD090090%282%29.jpg/500px-BD090090%282%29.jpg',
      tags: ['Castles', 'Towers'],
    },
    {
      id: 3,
      lat: 58.521165,
      lon: 31.275244,
      name: 'Millennium of Russia',
      photo:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Novgorod_Monument_LOC_06268u.jpg/600px-Novgorod_Monument_LOC_06268u.jpg',
      tags: ['Monuments'],
    },
    {
      id: 4,
      lat: 59.941065,
      lon: 30.317846,
      name: 'Hermitage Museum',
      photo:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Spb_06-2012_Palace_Embankment_various_14.jpg/540px-Spb_06-2012_Palace_Embankment_various_14.jpg',
      tags: ['Museums', 'Palaces'],
    },
    {
      id: 5,
      lat: 57.619265,
      lon: 39.904335,
      name: 'Strelka Park in Yaroslavl',
      photo:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Yaroslavl_Chelyuskintsev_Square_%282%29.jpg/560px-Yaroslavl_Chelyuskintsev_Square_%282%29.jpg',
      tags: ['Parks'],
    },
    {
      id: 6,
      lat: 55.796391,
      lon: 49.108891,
      name: 'Kazan Kremlin',
      photo:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/%D0%9A%D0%B0%D0%B7%D0%B0%D0%BD%D1%81%D0%BA%D0%B8%D0%B9_%D0%BA%D1%80%D0%B5%D0%BC%D0%BB%D1%8C._%D0%9F%D0%B0%D0%BD%D0%BE%D1%80%D0%B0%D0%BC%D0%B0_%D1%81_%D0%BA%D0%BE%D0%BB%D0%B5%D1%81%D0%B0_%D0%BE%D0%B1%D0%BE%D0%B7%D1%80%D0%B5%D0%BD%D0%B8%D1%8F.jpg/600px-%D0%9A%D0%B0%D0%B7%D0%B0%D0%BD%D1%81%D0%BA%D0%B8%D0%B9_%D0%BA%D1%80%D0%B5%D0%BC%D0%BB%D1%8C._%D0%9F%D0%B0%D0%BD%D0%BE%D1%80%D0%B0%D0%BC%D0%B0_%D1%81_%D0%BA%D0%BE%D0%BB%D0%B5%D1%81%D0%B0_%D0%BE%D0%B1%D0%BE%D0%B7%D1%80%D0%B5%D0%BD%D0%B8%D1%8F.jpg',
      tags: ['Сastles', 'Сhurches', 'Museums'],
    },
  ],
};
